// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__384ro","location":"Header_location__QS047"};